interface Option {
  value: number | string | null | undefined;
}
export function getIndexFor(
  needle: number | string | null | undefined,
  options?: Option[],
): number {
  return options
    ? options.findIndex(({ value }) => value === needle || (needle == null && value === ''))
    : -1;
}

export default { getIndexFor };
